<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="ko-phase-tree">
  @for (item of this.flattenedTree; track item.node.id) {
    <div [style]="this.getNodeStyle(item.column, item.row)">
      <ng-container *ngTemplateOutlet="this.template; context: item.node"></ng-container>
    </div>
  }
</div>
